import { render, staticRenderFns } from "./VirtualColleague.vue?vue&type=template&id=2062da73&scoped=true&"
import script from "./VirtualColleague.vue?vue&type=script&lang=js&"
export * from "./VirtualColleague.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2062da73",
  null
  
)

export default component.exports